import Vue from 'vue';
import loadingComponent from '@/components/loading.vue';

const loading = {
  install(Vue) {
    const loadingConstructor = Vue.extend(loadingComponent);
    const instance = new loadingConstructor();
    instance.$mount(document.createElement('div'));
    document.body.appendChild(instance.$el);
 
    Vue.prototype.$loading = {
      show() {
        instance.visible = true;
      },
      hide() {
        instance.visible = false;
      }
    }
  }
}
 
export default loading;